// extracted by mini-css-extract-plugin
module.exports = {"header":"Legend_header__2Lol_","label":"Legend_label__13VSZ","square":"Legend_square__n4ato","value":"Legend_value__Fpk_A","load":"Legend_load__2iOhw"};